import React, { useState, useEffect } from 'react';
import { X, Save, Trash2 } from 'lucide-react';

const EditMarketingPersonModal = ({ isOpen, onClose, person, onSave, onDelete }) => {
  const [formData, setFormData] = useState({
    name: '',
    daily_target: 16,
    commission_rate: 8,
    is_active: true
  });

  useEffect(() => {
    if (person) {
      setFormData({
        name: person.marketing_person_name || person.name || '',
        daily_target: person.total_target || 16,
        commission_rate: person.commission_rate || 8,
        is_active: person.is_active !== false
      });
    }
  }, [person]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(person.marketing_person_id || person.id, formData);
  };

  const handleDelete = () => {
    if (window.confirm(`Yakin ingin hapus ${formData.name}? Data tidak bisa dikembalikan.`)) {
      onDelete(person.marketing_person_id || person.id);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-background rounded-xl shadow-2xl max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-xl font-bold text-foreground">✏️ Edit Marketing Person</h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* Name */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Nama Lengkap <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="w-full px-3 py-2 bg-muted border border-border rounded-lg text-foreground focus:outline-none focus:border-primary"
              required
            />
          </div>

          {/* Daily Target */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Target Upload Harian <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              min="1"
              max="50"
              value={formData.daily_target}
              onChange={(e) => setFormData({ ...formData, daily_target: parseInt(e.target.value) })}
              className="w-full px-3 py-2 bg-muted border border-border rounded-lg text-foreground focus:outline-none focus:border-primary"
              required
            />
            <p className="text-xs text-muted-foreground mt-1">
              Recommended: 16 (4 IG + 4 TikTok + 4 FB + 4 YouTube)
            </p>
          </div>

          {/* Commission Rate */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Komisi Rate (%) <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              min="0"
              max="100"
              step="0.1"
              value={formData.commission_rate}
              onChange={(e) => setFormData({ ...formData, commission_rate: parseFloat(e.target.value) })}
              className="w-full px-3 py-2 bg-muted border border-border rounded-lg text-foreground focus:outline-none focus:border-primary"
              required
            />
            <p className="text-xs text-muted-foreground mt-1">
              Default: 8% dari nilai invoice
            </p>
          </div>

          {/* Active Status */}
          <div className="flex items-center space-x-3">
            <input
              type="checkbox"
              id="is_active"
              checked={formData.is_active}
              onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
              className="w-4 h-4 text-primary bg-muted border-border rounded focus:ring-primary"
            />
            <label htmlFor="is_active" className="text-sm text-foreground">
              Status Aktif (uncheck jika staff resign/cuti)
            </label>
          </div>

          {/* Actions */}
          <div className="flex justify-between pt-4 border-t border-border">
            <button
              type="button"
              onClick={handleDelete}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center space-x-2"
            >
              <Trash2 className="w-4 h-4" />
              <span>Delete</span>
            </button>
            <div className="flex space-x-2">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors flex items-center space-x-2"
              >
                <Save className="w-4 h-4" />
                <span>Save</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditMarketingPersonModal;